<template>
  <div>
    <div class="row justify-content-between">
      <div class="col-md-10">
        <h4>Campanhas Ativas</h4>
      </div>
      <div class="col-md-2">
        <router-link to="/create-campaign" class="btn create-campaign">Criar nova campanha</router-link>
      </div>
    </div>
    <div class="row campaigns-list" v-if="campaigns">
        <div class="row campaign" v-for="(c, k) in campaigns" v-bind:key="k">
          <div class="col-md-4">
            <div class="cover">
              <div class="info">
                <h2>{{c.name}}</h2>
                <h5>{{c.description}}</h5>
                <span>
                  Nenhum clique efetuado.
                </span>
              </div>
            </div>
          </div>
          <div class="col-md-8">
            <div class="row">
              <!-- <router-link class="btn" :to="'/campaign/manage'">Editar</router-link> -->
              <button class="btn" :to="'/campaign'">Ver Campanha</button>
              <button class="btn btn-danger" v-on:click.stop.prevent="">Excluir</button>
            </div>
            <div class="row">
              <button class="btn facebook-share">Compartilhe <font-awesome-icon :icon="['fab', 'facebook']" size="lg" /></button>
            </div>
          </div>
        </div>
    </div>
    <div class="row" v-else>
      <h4 class="campaigns-empty">Você não possui campanha. Crie uma agora!</h4>
    </div>
    
  </div>
</template>

<script>
import auth from '../../services/auth'
import Functions from '../../utils/functions'
import { API } from '../../services/api'
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import {faFacebookF} from '@fortawesome/fontawesome-free-brands'

export default {
  name: 'FormPartnerCampaign',
  props: ['user'],
  components: {
    FontAwesomeIcon
  },
  data () {
    return {
      campaigns: null,
    }
  },
  created(){
    this.loadUserData();
  },
  methods: {
    loadUserData(){
      this.campaigns = this.user ? this.user.PartnerCoupons : null;
    },
  },
  watch: { 
    user: function(newVal, oldVal) {
      this.loadUserData();
    }
  }
}
</script>

<style lang="scss" scoped>
.input-photo{
  display: none;
}
.form-campaign{
    margin-top: 20px;
    .row{
      padding: 20px;
      width: 100%;
      &:last-child{
        border-bottom: none;
      }
    }

    .profile-photo{
      width: 150px;
      height: 150px;
    }

    .change-photo{
      text-decoration: none;
      color: #333;
      margin-left: 20px;
    }

    .profile-data{
      .row{
        padding: 0px;
        border-bottom: none;
      }
    }

    .submit{
      font-size: 22px;
      color: #fff;
      background-color: #00AE39;
      &:hover{
        background-color: #aaa;
        color: #333;
      }
    }
  }

  h2{
  color: #00AE39;
  font-family: RalewayRegular;
}
.create-campaign{
  color: #fff;
  background-color: #00AE39;
  text-decoration: none;
  &:hover{
    background-color: #333;
  }
}

.campaigns-empty{
  width: 100%;
  padding: 20px;
  text-align: center;
  margin-top: 20px;
}

.campaigns-list{
  .campaign{
    margin-top: 10px;
    width: 100%;
    .row{
      padding-top: 0px;
    }
    &:first-child{
      margin-top: 0px;
      padding-top: 0px;
    }

    .visibility{
      background-color: #00AE39;
      color: #fff;
      padding: 15px;
      border-radius: 5px;
    }

    .btn{
      border: thin solid #00AE39;
      color: #00AE39;
      margin-right: 10px;

      &:hover{
        color: #fff;
        background-color: #00AE39;
      }

      &.facebook-share{
        background-color: #3b5998;
        color: #fff;
        border: none;
        font-size: 22px;
      }

      &.btn-danger{
        color: #fff;
        border: thin solid #c82333;

        &:hover{
          color: #fff;
          background-color: red;
        }
      }
    }
  }
  .cover{
    border: 2px solid #ccc;
    border-radius: 5px;
    padding-bottom: 10px;

    img{
      width: 100%;
    }
    .info{
      h2{
        font-size: 20px;
        font-family: RalewayRegular;
        margin-top: 10px;
        margin-left: 10px;
      }
      h5{
        margin-left: 10px;
        font-size: 16px;
      }
      span{
        display: block;
        margin-left: 10px;
        font-size: 14px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/profile/FormPartnerCampaign.vue